import React from "react";
import { Card, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsInfoCircle } from "react-icons/bs";
import { stepEducation } from "../utils/educationalContent";
import "./Timeline.css";

const formatDuration = (duration) => {
  const parts = [];
  if (duration.hours) {
    parts.push(`${duration.hours}h`);
  }
  if (duration.minutes) {
    parts.push(`${duration.minutes}m`);
  }
  if (duration.type === "flexible" && duration.max) {
    parts.push(`(up to ${duration.max}h)`);
  }
  return parts.join(" ");
};

const Timeline = ({ steps }) => {
  if (!steps) {
    return null;
  }

  return (
    <div className="timeline-container mt-4">
      {steps.map((step, index) => (
        <Row key={index} className="timeline-item">
          <Col
            xs={12}
            md={6}
            className={`timeline-content ${index % 2 === 0 ? "left" : "right"}`}
          >
            <Card className="mb-3">
              <Card.Body>
                <Card.Title className="d-flex align-items-center">
                  {step.name}
                  {stepEducation[step.name] && (
                    <OverlayTrigger
                      placement="top"
                      overlay={(props) => (
                        <Tooltip id={`tooltip-${step.name}`} {...props}>
                          {stepEducation[step.name].tip}
                        </Tooltip>
                      )}
                    >
                      <button
                        className="btn btn-link p-0 ms-2 text-primary"
                        type="button"
                      >
                        <BsInfoCircle />
                      </button>
                    </OverlayTrigger>
                  )}
                </Card.Title>
                <Card.Text>
                  <strong>Start:</strong>{" "}
                  {step.startTime.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                  <br />
                  <strong>End:</strong>{" "}
                  {step.endTime.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                  <br />
                  <strong>Duration:</strong> {formatDuration(step.duration)}
                  {step.temperatureDependent && step.duration.temperature && (
                    <>
                      <br />
                      <strong>Temperature:</strong> {step.duration.temperature}
                      °F
                      <br />
                      <small className="text-muted">
                        Duration adjusted for room temperature
                      </small>
                    </>
                  )}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default Timeline;
